module.exports = __webpack_public_path__ + "img/map_search_info_icon01.9be5d85b.svg";